import getDefaultShortenEventScope from './getDefaultShortenEventScope';
import getDefaultShouldEventsEndEarly from './getDefaultShouldEventsEndEarly';
import { ShortenEventScopeType } from '../shortenEventScopeTypeConstants';

/**
 * Gets whether the event should end early or not
 */
export default function getDefaultShouldShortenEventDurationEndEarly(): boolean {
    const shortenEventScope = getDefaultShortenEventScope();

    return shortenEventScope
        ? shortenEventScope === ShortenEventScopeType.EndEarly
        : getDefaultShouldEventsEndEarly();
}
